import { z } from 'zod/v4';

import { foldSynonyms, isString, normalizeFlatArgs } from './fold-helpers';

export const WIDGET_ID_SYNONYM_KEYS = ['id', 'widget_id'] as const;

const removeWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the widget to remove.'),
});

/**
 * Type-agnostic tool args — `remove_widget` works on any widget, so this lives at the
 * `widget-schemas/` root rather than under a per-type folder. No `data` field, so the flat-args
 * normalizer applies instead of `normalizeWidgetArgs`.
 */
export const removeWidgetArgsSchema = z.preprocess(
    (raw) => normalizeFlatArgs(raw, (args) => foldSynonyms(args, args, 'widgetId', WIDGET_ID_SYNONYM_KEYS, isString)),
    removeWidgetObjectSchema
);
